export enum DocType {
  REMOTE_PILOT_CERTIFICATE = 'Pilot or Recurrent Certificate (P107)',
  CERTIFICATE_OF_INSURANCE = 'Certificate of Insurance (COI)',
  CERTIFICATE_OF_AUTHORIZATION = 'Certificate of Authorization (COA)',
  EQUIPMENT_LOAN_AGREEMENT = 'Equipment Loan Agreement (ELA)',
  SERVICE_LEVEL_AGREEMENT = 'Service Level Agreement (SLA)',
  TAX_FORM_W9 = 'W9 Tax Form (W9)',
  TAX_FORM_1099 = '1099 Tax Form (1099)',
}

export enum DocumentStatus {
  WAITING_FOR_REVIEW = '1. Waiting for review',
  FIX_REQUESTED = '2. Fix requested',
  APPROVED = '3. Approved',
}

export type AirtableThumbnail = {
  url: string;
  height: number;
  width: number;
};

export type AirtableAttachment = {
  id: string;
  filename: string;
  size: number;
  thumbnails?: {
    large: AirtableThumbnail;
    small: AirtableThumbnail;
  };
  url: string;
};

export enum CoaStatus {
  ADVISED = 'Advised',
  REQUIRED = 'Required',
  WAITING_FOR_APPROVAL = 'Waiting for approval',
  APPROVED = 'Approved',
}

export type PilotDocRaw = {
  documentId: string;
  type: DocType;
  status: DocumentStatus;
  startDate?: string;
  endDate?: string;
  attachments?: AirtableAttachment[];
};

export type CoaProjectRaw = {
  projectId: string;
  accountName: string;
  projectName: string;
  coaStatus: CoaStatus;
  coaDocuments: PilotDocRaw[];
};

export enum CoiDuration {
  LESS_THAN_ONE_MONTH = 'Less than one month',
  ONE_MONTH = 'One month',
  MULTI_MONTH = 'Multi month',
  MULTI_YEAR = 'Multi-year',
}

export type DocsResponse = {
  coaProjects: CoaProjectRaw[];
  nonCOADocuments: PilotDocRaw[];
  coiDuration?: CoiDuration;
};

export type PilotDoc = {
  documentId: string;
  type: DocType;
  status: DocumentStatus;
  startDate?: Date;
  endDate?: Date;
  attachments?: AirtableAttachment[];
};

export type CoaProject = {
  projectId: string;
  accountName: string;
  projectName: string;
  coaStatus: CoaStatus;
};

export type CoaDocument = CoaProject & {
  document?: PilotDoc;
};
